const PUB = process.env.PUBLIC_URL || "";

export const PROFILE = {
  name: "Matteo Vilardo",
  title: {
    it: "Unity Developer / Backend Developer",
    en: "Unity Developer / Backend Developer",
  },
  description: {
    it: "Unity Developer e Backend Developer con circa 9 anni di esperienza tra mobile games, serious games, esperienze AR/VR e applicazioni 3D interattive. Backend in .NET",
    en: "Unity Developer and Backend Developer with about 9 years of experience across mobile games, serious games, AR/VR experiences and interactive 3D applications. Backend in .NET",
  },
  image: `${PUB}/images/fotoprofilo.jpeg`,
  contacts: {
    email: "info.matteo.vilardo@gmail.com",
    phone: "+39 3342230958",
    location: "Roma, Italia",
    linkedin: "https://www.linkedin.com/in/matteo-vilardo-87476713a/",
    upwork: "https://www.upwork.com/freelancers/~01c97aab06d723df2d?viewMode=1",
    itch: "https://malo-interactive.itch.io/",
    cv: {
      it: `${PUB}/cv/Vilardo_Matteo_CV_it.pdf`,
      en: `${PUB}/cv/Vilardo_Matteo_Resume_GameDev_en.pdf`,
    },
  },
};
